<template>
  <div
    class="overflow-auto max-h-screen pb-40 md:pb-56 rounded-t-xxl md:rounded-xxl md:m-12 mt-6"
    :style="(landingsPageBackground, landingsPageSelectionBackgroundUrl)"
  >
    <div class="">
      <div class="flex items-center justify-center mb-4 mt-2">
        <img
          class="h-32 rounded-md object-contain"
          :src="
            landingPage.logo_url
              ? landingPage.logo_url
              : require('../assets/images/Menu.Logo.png')
          "
          alt="Logo"
        />
      </div>
    </div>
    <div
      class="rounded-t-xxl px-4 flex flex-col justify-center items-center self-center h-full"
      :style="makeStyles(hasKiosk && mainSectionTopRadius , landingsPageSelectionBackground)"
    >
      <p class="font-bold text-3xl text-center" :style="landingsPageTitle">
        {{ landingPage["title"] }}
      </p>
      <div
        class="mb-4 text-md md:text-3xl text-product-gray font-bold"
        :style="landingsPageTitle"
      >
        {{ landingPage["description"] }}
      </div>
      <div class="flex mb-8 flex-row flex-wrap justify-center">
        <a
          v-for="menu in landingPage.menus"
          :key="menu.Id"
          @click="menu.is_delivery_menu ? deliveryMode() : ''"
          class="mr-2 mb-2 bg-primary-100 w-40 md:w-64 text-new-primary font-semibold text-center text-xl flex flex-col justify-center items-center rounded-xl md:py-20 p-2"
          :href="`/${menu.menu_hash}/${tableId}`"
          :style="landingsPageItemBackground"
          v-show="menu.is_ordering_enabled"
        >
          <img
            class="h-32 rounded-md object-contain"
            :src="
              menu.icon_url
                ? menu.icon_url
                : require('../assets/images/Menu.Logo.png')
            "
            alt="Logo"
          />
          <p :style="landingsPageItemTitle">{{ menu.title }}</p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      tableId: "",
    };
  },
  computed: {
    ...mapGetters(["landingPage","hasKiosk"]),
    ...mapGetters("Theme", [
      "mainSectionTopRadius",
      "landingsPageSelectionBackground",
      "landingsPageItemBackground",
      "landingsPageTitle",
      "landingsPageItemTitle",
      "landingsPageSelectionBackgroundUrl",
    ]),
  },
  mounted() {
    if (this.$route.query.tableId) {
      this.tableId = this.$route.query.tableId;
    }
  },
  methods: {
    deliveryMode() {
      localStorage.setItem("delivery", true);
      localStorage.setItem("currentOption", "Delivery");
      this.$store.commit("Cart/updateHomeDelivery", true);
    },
  },
};
</script>
